import {Component, Input} from '@angular/core';
import {AppAbility, PermissionsService} from "../../../../services/shared/permissions.service";
import {IsMobileService} from "../../../../services/is-mobile/is-mobile.service";
import {Permission} from "../../../../enums/permissions/Permission";

@Component({
  selector: 'app-sidebar-layout',
  templateUrl: './sidebar-layout.component.html',
  styleUrls: ['./sidebar-layout.component.css']
})
export class SidebarLayoutComponent {
  @Input() menuItems: any[] = [];
  @Input() title: string = '';
  currentUser: any;
  showMenu = true;

  sidebarVisible = true;
  isMobile = false;
  ability: AppAbility | undefined;

  constructor(private isMobileService: IsMobileService) {
    this.currentUser = JSON.parse(localStorage.getItem('account') || '{}');
  }

  ngOnInit(): void {
    this.isMobileService.isMobile$.subscribe((isMobile) => {
      this.isMobile = isMobile;
    });
  }

  protected readonly Permission = Permission;
}
